import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "SportsQuickLinksWidget" */ './SportsQuickLinksWidget'),
  modules: ['./SportsQuickLinksWidget'],
  loading: () => <div />
});

export default LoadableWidget;
